import imgChatel from '../assets/pictures/CHATEL-82.jpg';
import imgDolomites from '../assets/pictures/DOLOMITES-125.jpg';
import imgMartinswand from '../assets/pictures/MARTINSWAND-65.jpg';

export const images = [
    imgChatel,
    imgDolomites,
    imgMartinswand,
    imgChatel,
    imgDolomites,
    imgMartinswand,
    imgChatel,
    imgDolomites,
    imgMartinswand,
    imgChatel,
    imgDolomites,
    imgMartinswand,
];

export const perspectives = [
    {
        title: 'The Vision',
        description: 'Capturing moments that tell a story, one frame at a time.',
        position: 'top',
    },
    {
        title: 'The Journey',
        description: 'From urban landscapes to wild mountains, the journey never stops.',
        position: 'center',
    },
    {
        title: 'The Craft',
        description: 'Honing the skills of light, shadow, and composition.',
        position: 'center',
    },
    {
        title: 'The Silence',
        description: 'Finding peace in the quiet moments of observation.',
        position: 'bottom',
    },
    {
        title: 'The Motion',
        description: 'Life is always moving, and so is the lens.',
        position: 'top-right',
    },
    {
        title: 'The Future',
        description: 'Exploring new technologies and creative boundaries.',
        position: 'center',
    },
];

export const cylinderConfig = {
    radius: window.innerWidth > 768 ? 2.5 : 1.8,
    height: window.innerWidth > 768 ? 2 : 1.0,
    radialSegments: 64,
    heightSegments: 1,
};

export const particleConfig = {
    numParticles: 12,
    particleRadius: 3.3, // cylinderRadius + 0.8
    segments: 20,
    angleSpan: 0.3,
};

export const imageConfig = {
    width: 1024,
    height: 1024,
};
